import React from 'react'

function Thanks(){
    
    return(
          <div className="content thanks">
              <div className="imgBox">
                  <img src="assets/images/icon-thank-you.svg" alt="" />
              </div>
              <h2>Thank you!</h2>
              <p>Thanks for confirming your subscription! We hope you have fun using our platform. If you ever need support, please feel free to email us at support@loremipsum.com</p>
          </div>
    )
}

export default Thanks